import { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";

import { UserContext } from "../../context/UserContext";
import Sentry, { sentryEnabled } from "../../lib/sentry";

export default function SentryUserContext() {
  const location = useLocation();
  const [
    ,
    ,
    ,
    venueID,
    venueName,
    ,
    email,
    accessPrivileges,
    ,
    ,
    venueType,
    venueActivationStatus,
    venueSubscriptionStatus,
  ] = useContext(UserContext);

  useEffect(() => {
    if (!sentryEnabled) {
      return;
    }

    if (email) {
      Sentry.setUser({
        id: email,
        email,
      });
    } else {
      Sentry.setUser(null);
    }
  }, [email]);

  useEffect(() => {
    if (!sentryEnabled) {
      return;
    }

    Sentry.setTag("access_privileges", accessPrivileges || "anonymous");
    Sentry.setTag("venue_activation_status", venueActivationStatus || "pending");
    Sentry.setTag("venue_subscription_status", venueSubscriptionStatus || "none");

    if (venueID) {
      Sentry.setTag("venue_id", String(venueID));
    }

    if (venueType) {
      Sentry.setTag("venue_type", venueType);
    }

    Sentry.setContext("venue", {
      id: venueID ? String(venueID) : null,
      name: venueName || null,
      type: venueType || null,
      activation_status: venueActivationStatus || null,
      subscription_status: venueSubscriptionStatus || null,
    });
  }, [accessPrivileges, venueActivationStatus, venueID, venueName, venueSubscriptionStatus, venueType]);

  useEffect(() => {
    if (!sentryEnabled) {
      return;
    }

    Sentry.setTag("route", location.pathname);
    Sentry.addBreadcrumb({
      category: "navigation",
      message: location.pathname,
      level: "info",
    });
  }, [location.pathname]);

  return null;
}
